const palette = {
  blue: {
    bg: 'bg-blue-50',
    icon: 'bg-blue-100 text-blue-600',
    value: 'text-blue-700',
    border: 'border-blue-100',
  },
  green: {
    bg: 'bg-emerald-50',
    icon: 'bg-emerald-100 text-emerald-600',
    value: 'text-emerald-700',
    border: 'border-emerald-100',
  },
  purple: {
    bg: 'bg-violet-50',
    icon: 'bg-violet-100 text-violet-600',
    value: 'text-violet-700',
    border: 'border-violet-100',
  },
  yellow: {
    bg: 'bg-amber-50',
    icon: 'bg-amber-100 text-amber-600',
    value: 'text-amber-700',
    border: 'border-amber-100',
  },
};

const StatsCard = ({ label, value, icon, color = 'blue', trend }) => {
  const p = palette[color] || palette.blue;
  return (
    <div className={`${p.bg} rounded-2xl border ${p.border} p-5 flex items-start gap-4 hover:shadow-card-md transition-shadow duration-200`}>
      <div className={`w-11 h-11 rounded-xl flex items-center justify-center text-xl flex-shrink-0 ${p.icon}`}>
        {icon}
      </div>
      <div className="min-w-0">
        <p className="text-sm text-slate-500 font-medium truncate">{label}</p>
        <p className={`text-2xl font-bold mt-0.5 ${p.value}`}>{value ?? '—'}</p>
        {trend !== undefined && (
          <p className="text-xs text-slate-400 mt-1">{trend}</p>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
